import { render, staticRenderFns } from "./TgArticleMain.vue?vue&type=template&id=7c1fea20&"
import script from "./TgArticleMain.vue?vue&type=script&lang=js&"
export * from "./TgArticleMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports